function matchesRoute(pathname: string, route: string): boolean {
  if (route === '/') return pathname === '/';
  return pathname === route || pathname.startsWith(`${route}/`);
}

/**
 * 返回当前地址对应的最具体后台功能入口。比如 /drama/teams 优先于 /drama，
 * /account/users/42 则归属 /account。
 */
export function resolveKnownAdminPath(pathname: string, knownPaths: readonly string[]) {
  return [...knownPaths]
    .sort((left, right) => right.length - left.length)
    .find((route) => matchesRoute(pathname, route));
}

export function canAccessAdminPath(
  pathname: string,
  knownPaths: readonly string[],
  allowedPaths: readonly string[],
): boolean {
  const knownPath = resolveKnownAdminPath(pathname, knownPaths);
  if (!knownPath) return true;
  return allowedPaths.includes(knownPath);
}
